module.exports = __webpack_public_path__ + "img/codepen.22dfc344.svg";